/* PIDJAY's scroll introduction; no scroll interception or animation libraries. */
(function () {
  'use strict';

  if (window.PidjayCinema) {
    window.PidjayCinema.init(document);
    return;
  }

  var instances = new Map();
  var colors = ['white', 'black', 'navy', 'brown', 'grey'];

  function createCinema(cinema) {
    var stage = cinema.querySelector('.cinema-stage');
    if (!stage) return function () {};
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scenes = Array.from(cinema.querySelectorAll('[data-cinema-scene]'));
    var products = Array.from(cinema.querySelectorAll('[data-cinema-color]'));
    var angle = cinema.querySelector('[data-cinema-angle]');
    var product = cinema.querySelector('.cinema-product');
    var eyebrow = cinema.querySelector('[data-cinema-eyebrow]');
    var headlineBase = cinema.querySelector('[data-cinema-headline="base"]');
    var headlineColor = cinema.querySelector('[data-cinema-headline="color"]');
    var colorLabel = cinema.querySelector('[data-cinema-color-label]');
    var swatches = Array.from(cinema.querySelectorAll('[data-cinema-swatch]'));
    var steps = Array.from(cinema.querySelectorAll('[data-cinema-step]'));
    var scrollLabel = cinema.querySelector('[data-cinema-scroll-label]');
    var counter = cinema.querySelector('[data-cinema-counter]');
    var frame = 0;
    var previousScene = -1;

    function render() {
      frame = 0;
      var reduced = motion.matches;
      cinema.classList.toggle('reduced', reduced);
      var rect = cinema.getBoundingClientRect();
      var offset = parseFloat(window.getComputedStyle(stage).top) || 0;
      var travel = Math.max(1, rect.height - window.innerHeight + offset);
      var progress = reduced ? 0 : Math.max(0, Math.min(1, (offset - rect.top) / travel));
      var scene = progress < 0.12 ? 0 : progress < 0.32 ? 1 : progress < 0.58 ? 2 : progress < 0.74 ? 3 : progress < 0.9 ? 4 : 5;
      var colorIndex = Math.max(0, Math.min(4, Math.floor((progress - 0.32) / 0.052)));

      if (scene !== previousScene) {
        if (previousScene >= 0) stage.classList.remove('scene-' + previousScene);
        stage.classList.add('scene-' + scene);
        scenes.forEach(function (element) {
          var visible = element.dataset.cinemaScene.split(',').indexOf(String(scene)) !== -1;
          element.style.opacity = visible ? '1' : '0';
          element.setAttribute('aria-hidden', visible ? 'false' : 'true');
          element.toggleAttribute('inert', !visible);
          if (element.classList.contains('enter-scene')) {
            element.style.pointerEvents = visible ? 'auto' : 'none';
            element.querySelectorAll('a').forEach(function (link) {
              link.tabIndex = visible ? 0 : -1;
            });
          }
        });
        steps.forEach(function (step, index) { step.classList.toggle('active', index === scene); });
        if (scrollLabel) scrollLabel.textContent = scene === 0 ? 'SCROLL TO DISCOVER' : 'KEEP EXPLORING';
        if (counter) counter.textContent = '0' + (scene + 1) + ' / 06';
        if (eyebrow) eyebrow.textContent = scene === 2 ? 'A PALETTE FOR YOUR EVERYDAY' : 'A NEW PERSPECTIVE ON THE EVERYDAY';
        if (headlineBase) headlineBase.style.display = scene === 2 ? 'none' : '';
        if (headlineColor) headlineColor.style.display = scene === 2 ? '' : 'none';
        previousScene = scene;
      }

      var selectedColor = scene === 2 ? colors[colorIndex] : 'white';
      var showAngle = scene === 1 && progress >= 0.235;
      products.forEach(function (image) {
        image.style.opacity = image.dataset.cinemaColor === selectedColor && !showAngle ? '1' : '0';
      });
      if (angle) angle.style.opacity = showAngle ? '1' : '0';
      if (colorLabel) colorLabel.textContent = scene === 2 ? selectedColor.toUpperCase() : 'THE EVERYDAY CREW';
      swatches.forEach(function (swatch, index) { swatch.classList.toggle('active', index === (scene === 2 ? colorIndex : 0)); });
      if (product) product.style.transform = reduced ? '' : 'scale(' + (1 + Math.min(0.08, Math.max(0, (progress - 0.12) * 0.4))) + ') rotate(' + (scene === 1 ? (progress - 0.2) * 8 : 0) + 'deg)';
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(render);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    motion.addEventListener('change', schedule);
    render();

    return function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      motion.removeEventListener('change', schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }

  function init(scope) {
    scope.querySelectorAll('[data-pidjay-cinema]').forEach(function (cinema) {
      if (!instances.has(cinema)) instances.set(cinema, createCinema(cinema));
    });
  }

  function destroy(scope) {
    instances.forEach(function (cleanup, cinema) {
      if (scope.contains(cinema)) {
        cleanup();
        instances.delete(cinema);
      }
    });
  }

  window.PidjayCinema = { init: init, destroy: destroy };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
}());
